export const CommunityType = {
  PUBLIC: 'public',
  PRIVATE: 'private'
}
